export async function obtenerEstructuraCompleta() {
  const response = await fetch("https://dev.dimalink.cl/api/Mobile/1/estructura-completa", {
    headers: {
      Accept: "text/plain",
    },
  });
  if (!response.ok) throw new Error("Error al obtener estructura completa");

  const text = await response.text();
  // Si el texto es JSON, parsealo:
  try {
    return JSON.parse(text);
  } catch {
    return text; // si no es JSON, retorna el texto puro
  }
}
